import { lazy, Suspense } from "react";
import { Toaster } from "react-hot-toast";
import { useSearchParams } from "react-router-dom";
import { ENDPOINT_API_DOCS_SPEC_PARAM } from "@app/shared/src/components/Integrations/EndpointApiDocs/paths";

// Lazy: keeps the (large) Scalar OpenAPI viewer and the embedded specs out of the main dashboard bundle.
const EndpointApiDocs = lazy(() =>
    import("@app/shared/src/components/Integrations/EndpointApiDocs").then((m) => ({ default: m.EndpointApiDocs }))
);

export const EndpointApiDocsPage: React.FC = () => {
    const [params, setParams] = useSearchParams();
    return (
        <Suspense fallback={<div className="p-4">Loading...</div>}>
            {/* This page renders full-bleed rather than inside DashboardLayout — the viewer owns the whole
                viewport and the print stylesheet hides everything outside it — so it doesn't inherit that
                layout's Toaster and has to mount its own for the unknown-spec warning to be seen. */}
            <Toaster />
            <EndpointApiDocs
                specId={params.get(ENDPOINT_API_DOCS_SPEC_PARAM)}
                // Keep the query string in step with the header picker so the URL stays shareable.
                // Replace rather than push: switching interfaces is changing what you're reading, not a
                // step in a journey, and pushing would make Back walk every spec you looked at instead of
                // leaving the page.
                onSpecChange={(specId) => setParams({ [ENDPOINT_API_DOCS_SPEC_PARAM]: specId }, { replace: true })}
            />
        </Suspense>
    );
};
